import IcoMoon from '@/components/IcoMoon'
import { useNavigation } from '@/context/navigation'
import classNames from 'classnames/bind'
import Link from 'next/link'
import * as styles from './style'

const cx = classNames.bind(styles)

export interface Props {
  className?: string
  hasPopOut?: boolean
  label: string
  url?: string
  openInNewTab: boolean
  path?: string
}

const MenuLink = ({ className = '', hasPopOut = false, label, url, openInNewTab, path }: Props): JSX.Element => {
  const {
    state: { searchBox },
    dispatch,
  } = useNavigation()

  const classes = cx({
    root: true,
    link: true,
    [`${className}`]: true,
  })

  function hideSearchMenu(): void {
    if (searchBox.open) {
      dispatch({ type: 'SET_SEARCH_OPEN', payload: false })
    }
  }

  return (
    <>
      {path ? (
        <Link className={classes} href={path} onClick={hideSearchMenu}>
          {label}
        </Link>
      ) : (
        <a
          data-testid="external-link"
          href={url}
          className={classes}
          title={label}
          target={openInNewTab ? '_blank' : '_self'}
          onClick={hideSearchMenu}
        >
          <span>{label}</span>
          {hasPopOut && (
            <span className={styles.hasPopOut}>
              <IcoMoon icon="popout" size={10} />
            </span>
          )}
        </a>
      )}
    </>
  )
}
export default MenuLink
